import { FieldValues } from 'react-hook-form'
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Checkbox } from '@/common/ui/checkbox'
import { GameSettingsFieldsProps } from '../types'
import { GameType } from '@/modules/promotion/type'
import { GameProviderSelector } from '@/modules/promotion/components/GameProviderSelector'
import useQueryGetGameProviderList from '@/modules/game/api/hooks/useQueryGetGameProviderList'

export function GameSettingsFields<
	TFieldValues extends FieldValues = FieldValues,
>({ control, fieldPrefix = '' }: GameSettingsFieldsProps<TFieldValues>) {
	const getFieldName = (field: string) =>
		fieldPrefix ? `${fieldPrefix}.${field}` : field

	const { data: gameProviders } = useQueryGetGameProviderList({
		skip: 0,
		take: 1000,
	})

	return (
		<div className="space-y-4">
			<FormField
				control={control}
				name={getFieldName('gameTypes') as any}
				render={() => (
					<FormItem>
						<FormLabel className="text-sm sm:text-base">
							ประเภทเกมที่เข้าร่วม
						</FormLabel>
						<div className="flex flex-wrap gap-2 sm:gap-3">
							{[
								GameType.SLOT,
								GameType.FISHING,
								GameType.CASINO,
								GameType.LOTTO,
								GameType.SPORT,
							].map((type) => (
								<FormField
									key={type}
									control={control}
									name={getFieldName('gameTypes') as any}
									render={({ field }) => (
										<FormItem className="flex items-center gap-2">
											<FormControl>
												<Checkbox
													checked={field.value?.includes(type as any)}
													onCheckedChange={(checked) => {
														const updatedValue = checked
															? [...(field?.value || []), type]
															: field.value?.filter(
																	(value: GameType) => value !== type,
																)
														field.onChange(updatedValue)
													}}
												/>
											</FormControl>
											<FormLabel className="text-sm sm:text-base">
												{type}
											</FormLabel>
										</FormItem>
									)}
								/>
							))}
						</div>
						<FormMessage />
					</FormItem>
				)}
			/>

			<FormField
				control={control}
				name={getFieldName('whitelistGameProviders') as any}
				render={({ field }) => (
					<FormItem>
						<FormLabel className="text-sm sm:text-base">
							ผู้ให้บริการเกมที่ร่วม
						</FormLabel>
						<FormControl>
							<GameProviderSelector
								field={field}
								gameProviders={gameProviders?.data}
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	)
}
